import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgreementSignService {
  private signingURL = 'http://localhost:13589/signing';

  constructor(private http: HttpClient) {}

  pullSigningData(referenceCode: string ): Observable<any> {
    return this.http.get(`iam-invoice/agreement-content/${referenceCode}/sign/pull`);
  }

  pushSignedData(data: {
    referenceCode: string;
    base64FileData: string;
    signedByPartyId?: string;
    signedByName?: string;
    signedByRole?: string;
  }): Observable<any> {
    return this.http.post(`iam-invoice/agreement-content/${data.referenceCode}/sign/push`, data);
  }

  async signWithTool(data: {
    referenceNumber: string;
    baseUrl: string;
    signingBlocks?: any[];
    fileName?: string;
    pdfBase64?: string;
    signedBy: string;
  }): Promise<any> {
    try {
      const response = await fetch(this.signingURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          baseUrl: data.baseUrl
        })
      });

      if (!response.ok) {
        if (response.status === 0) {
          // Tool chưa được cài đặt
          const error: any = new Error('Tool ký chưa được cài đặt. Vui lòng tải và cài đặt tool ký trước.');
          error.isPluginError = true;
          throw error;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error: any) {
      if (error?.code === 'ERR_NETWORK' || error?.message?.includes('Failed to fetch')) {
        const pluginError: any = new Error('Tool ký chưa được cài đặt hoặc chưa khởi động. Vui lòng kiểm tra lại.');
        pluginError.isPluginError = true;
        throw pluginError;
      }
      throw error;
    }
  }
}
